import React, { useState } from 'react';
import proptypes from 'prop-types';
import { Tile as TileElement, TileContent, TileText } from '@one-thd/sui-atomic-components';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { TooltipContent } from '../tooltip-content/tooltip-content';

const { string, shape, bool, func, } = proptypes;

export const Tile = (props) => {
  const {
    isSelected,
    isAvailable,
    isFabricType,
    value,
    onClick,
    onMouseEnter,
    onMouseLeave,
    isTooltipsEnabled,
    hoveredCombinationDetails,
    channel
  } = props;
  const [isHovered, setIsHovered] = useState(false);

  const shouldShowTooltip = isHovered && isTooltipsEnabled && hoveredCombinationDetails?.combinationDetails;

  const mouseEnter = (event) => {
    setIsHovered(true);
    onMouseEnter(event);
  };
  const mouseLeave = (event) => {
    setIsHovered(false);
    onMouseLeave(event);
  };
  const tileChild = (
    <div onMouseEnter={mouseEnter} onMouseLeave={mouseLeave}>
      <TileElement
        onClick={onClick}
        aria-label={value}
        value={value}
        selected={isSelected}
        unavailable={!isAvailable && !isFabricType}
        data-testid="text-tile"
      >
        <TileContent>
          <TileText>
            {value}
          </TileText>
        </TileContent>
      </TileElement>
    </div>
  );

  return (shouldShowTooltip
    ? (
      <Tooltip
        channel={channel}
        content={<TooltipContent hoveredCombinationDetails={hoveredCombinationDetails} />}
        interactive
      >
        {tileChild}
      </Tooltip>
    )
    : (tileChild)
  );
};

Tile.displayName = 'Tile';

Tile.propTypes = {
  channel: string,
  value: string.isRequired,
  isAvailable: bool.isRequired,
  isFabricType: bool,
  isSelected: bool.isRequired,
  onClick: func.isRequired,
  onMouseEnter: func.isRequired,
  onMouseLeave: func.isRequired,
  isTooltipsEnabled: bool,
  hoveredCombinationDetails: shape({})
};

Tile.defaultProps = {
  channel: 'desktop',
  hoveredCombinationDetails: {},
  isFabricType: false,
  isTooltipsEnabled: false
};
